// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
// import * as ActiveStorage from "@rails/activestorage"
// import "channels"
import "../pages/shared/shared"

Rails.start()
// Turbolinks.start()
// ActiveStorage.start()

// Search bar
document.querySelectorAll("a[href='#search']").forEach(v => {
  v.addEventListener("click", e => {
    e.preventDefault();
    if (document.querySelector(".press-articles.search-results"))
      return;

    document.querySelector(".search-bar").classList.toggle("open");
  });
});
